import * as Config from "configuration";
import * as Auth from "oauth2";
const origin = Config.get("apiNotification");
const TIMEOUT = 10000;
export async function fetchExpoSubscribe(token) {
    const url = `${origin}/api/notification/subscribe`;
    return Auth.fetch(url, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ token }),
    }, TIMEOUT);
}
export function fetchExpoUnsubscribe(token) {
    const url = `${origin}/api/notification/unsubscribe`;
    return Auth.fetch(url, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ token }),
    }, TIMEOUT);
}
export async function fetchSubscriptions() {
    const url = `${origin}/api/notification/subscriptions`;
    return Auth.fetch(url, { method: "POST" }, TIMEOUT);
}
